import { render, staticRenderFns } from "./PartnersTiles.vue?vue&type=template&id=9e792788&"
import script from "./PartnersTiles.vue?vue&type=script&lang=js&"
export * from "./PartnersTiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports